import React, { useEffect, useRef, useState } from "react";
import "./DosaChutneyHome.scss"
import heroBackground from "../../assets/images/carousel.png"
import heroBackgroundMob from "../../assets/images/carouselMob.png"
import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import { useSelector } from "react-redux";
import MapLocationComponent from "../../components/Footer/MapLocationComponent";
import tableBooking from "../../assets/images/tableBooking.jpg"
import border from "../../assets/images/border.png"
import pattern from "../../assets/images/pattern.png"
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import specialMenuImg from "../../assets/images/specialMenu.png"
import MenuSliderComponent from "../../components/MenuSlider/MenuSliderComponent";
import ReviewSlider from "../../components/ReviewSlider/ReviewSlider";
import { sortByOrderAscending } from "../../helper/helper";
import { useHistory } from "react-router";



const DosaChutneyHome = () => {
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [email, setEmail] = useState("")
    const [errors, setErrors] = useState({
        email: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const history = useHistory()
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "home")
    const Components = page?.Components || []

    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;

        const newErrors = {
            email: ""
        };

        const trimmedEmail = email.trim();

        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.companyID || "",
            "Name": "",
            "Email": email,
            "PhoneNo": "",
            "Message": "",
            "Subject": "Dosa N Chutney",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        // const container = containerRef.current;
        // const content = contentRef.current;

        // if (!container || !content) return;

        // let scrollLeft = 0;
        // let animationFrame;

        // const clone = content.cloneNode(true);
        // container.appendChild(clone);

        // const animate = () => {
        //     scrollLeft += 0.5;
        //     if (scrollLeft >= content.scrollWidth) {
        //         scrollLeft = 0;// Reset seamlessly
        //     }
        //     container.scrollLeft = scrollLeft;
        //     animationFrame = requestAnimationFrame(animate);
        // };

        // animationFrame = requestAnimationFrame(animate);

        // return () => cancelAnimationFrame(animationFrame);
    }, []);
    const getImagesCarousel = (data) => {
        return (
            <div className="DosaChutneyHome-ImageCarousel" ref={containerRef}>
                <div className="DosaChutneyHome-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="DosaChutneyHome-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const HeaderText = ({ subheader, header, content }) => {
        return (
            <div className="DosaChutneyHome-HeaderText">
                {subheader && <div className="DosaChutneyHome-HeaderText-subheader">
                    {subheader}
                </div>}
                <div className="DosaChutneyHome-HeaderText-header">
                    {header}
                </div>
                <img alt="" src={border} className="DosaChutneyHome-HeaderText-border" />
                {content && <div className="DosaChutneyHome-HeaderText-content">
                    {content}  </div>}
            </div>
        )
    }
    const getMenuComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Container-Menu-header":
                return <HeaderText
                    subheader={component?.Props?.subheader}
                    header={component?.Props?.header} />
            case "DosaChutneyHome-Container-Menu-menu":
                return <MenuSliderComponent />
            default:
                return <div />
        }
    }
    const getMenu = (components) => {
        return (
            <div className="DosaChutneyHome-Menu">
                {sortByOrderAscending(components).map((component, key) => {
                    return getMenuComponents(component)
                })}
            </div>
        )
    }
    const getReviewsComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Container-Menu-header":
                return <HeaderText
                    subheader={component?.Props?.subheader}
                    header={component?.Props?.header}
                    content={component?.Props?.content} />
            case "DosaChutneyHome-Container-Menu-review":
                return <ReviewSlider
                    items={component?.Data} />
            default:
                return <div />
        }
    }
    const getReviews = (components) => {
        return (
            <div className="DosaChutneyHome-Menu">
                {sortByOrderAscending(components).map((component, key) => {
                    return getReviewsComponents(component)
                })}
            </div>
        )
    }
    const getAboutLeftImageComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-About-left-imgs-left":
                return <div className="DosaChutneyHome-About-left-imgs-left">
                    {component?.Data?.map((data, key) => {
                        return <img alt="" key={key} src={data?.src} className={data?.isMobile ? "DosaChutneyHome-About-left-imgs-left-mob" : "DosaChutneyHome-About-left-imgs-left-web"} />

                    })}
                </div >
            case "DosaChutneyHome-About-left-imgs-right":
                return <img alt="" src={component?.Props?.src} className="DosaChutneyHome-About-left-imgs-right" />

            default:
                return <div />
        }
    }
    const getAboutLeftComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Container-About-left-component":
                return <div className="DosaChutneyHome-About-left-imgs">
                    {sortByOrderAscending(component?.Components).map((component, key) => {
                        return getAboutLeftImageComponent(component)
                    })}
                </div>
            case "DosaChutneyHome-Container-About-left-image":
                return <img alt="" src={component?.Props?.src} className="DosaChutneyHome-About-left-image" />

            default:
                return <div />
        }
    }
    const getAboutLeft = (components) => {
        return (
            <div className="DosaChutneyHome-About-left">
                {/* <div className="DosaChutneyHome-About-left-imgs">
                    <div className="DosaChutneyHome-About-left-imgs-left">
                        <img alt="" src="https://media.istockphoto.com/id/849749746/photo/middle-eastern-meze-platter-with-green-falafel-pita-sun-dried-tomatoes-pumpkin-and-beet-hummus.jpg?s=612x612&w=0&k=20&c=jxRzenS_xqbmHnBOYRziLAzDP1faJMAjvznMUncKM1s=" className="DosaChutneyHome-About-left-imgs-left-web" />
                        <img alt="" src="https://images.unsplash.com/photo-1694849789325-914b71ab4075?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZG9zYXxlbnwwfHwwfHx8MA%3D%3D" className="DosaChutneyHome-About-left-imgs-left-web" />
                        <img alt="" src="https://images.unsplash.com/photo-1710091691777-3115088962c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJpY2UlMjBhbmQlMjBjdXJyeXxlbnwwfHwwfHx8MA%3D%3D" className="DosaChutneyHome-About-left-imgs-left-mob" />
                        <img alt="" src="https://media.istockphoto.com/id/2254897372/photo/indian-dish-chicken-biryani-with-basmati-rice.jpg?s=612x612&w=0&k=20&c=En3louo6gNPC555Lin_9GSZCcSS8JnsOo0n30qeFGDQ=" className="DosaChutneyHome-About-left-imgs-left-mob" />
                        <img alt="" src="https://media.istockphoto.com/id/1156896083/photo/cheese-masala-dosa-recipe-with-sambar-and-chutney-selective-focus.jpg?s=612x612&w=0&k=20&c=Wyy0uUGXfQn7JstC8w0DsxWJVGnqWUJUCG53a42UH9s=" className="DosaChutneyHome-About-left-imgs-left-mob" />

                    </div>
                    <img alt="" src="https://images.unsplash.com/photo-1710091691777-3115088962c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJpY2UlMjBhbmQlMjBjdXJyeXxlbnwwfHwwfHx8MA%3D%3D" className="DosaChutneyHome-About-left-imgs-right" />
                </div> */}
                {sortByOrderAscending(components).map((component, key) => {
                    return getAboutLeftComponent(component)
                })}
            </div>
        )
    }
    const getAboutRightTextComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Container-About-right-component-header":
                return <HeaderText
                    subheader={component?.Props?.subheader}
                    header={component?.Props?.header} />
            case "DosaChutneyHome-Container-About-right-component-headerText":
                return <div className="DosaChutneyHome-About-right-cont-headerText">
                    {component?.Props?.text}
                </div >
            case "DosaChutneyHome-Container-About-right-component-content":
                return <div className="DosaChutneyHome-About-right-cont-content">
                    {component?.Props?.text}
                </div >
            default:
                return <div />
        }
    }
    const getAboutRightComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Container-About-right-component":
                return <div className="DosaChutneyHome-About-right-cont">
                    {sortByOrderAscending(component?.Components).map((component, key) => {
                        return getAboutRightTextComponent(component)
                    })}
                </div>
            case "DosaChutneyHome-Container-About-right-image":
                return <img alt="" src={component?.Props?.src} className="DosaChutneyHome-About-right-imgs" />

            default:
                return <div />
        }
    }
    const getAboutRight = (components) => {
        return (
            <div className="DosaChutneyHome-About-right">
                {sortByOrderAscending(components).map((component, key) => {
                    return getAboutRightComponent(component)
                })}
            </div>
        )
    }
    const getAboutComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Container-About-left":
                return getAboutLeft(component?.Components)
            case "DosaChutneyHome-Container-About-right":
                return getAboutRight(component?.Components)
            default:
                return <div />
        }
    }
    const getAbout = (components) => {
        return (
            <div className="DosaChutneyHome-About">
                {sortByOrderAscending(components).map((component, key) => {
                    return getAboutComponent(component)
                })}
            </div>
        )
    }
    const getTableBookingComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-TableBooking-subheader":
                return <div className="DosaChutneyHome-TableBooking-subheader">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyHome-TableBooking-header":
                return <div className="DosaChutneyHome-TableBooking-header">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyHome-TableBooking-border":
                return <img alt="" src={border} className="DosaChutneyHome-TableBooking-border" />
            case "DosaChutneyHome-TableBooking-content":
                return <div className="DosaChutneyHome-TableBooking-content">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyHome-TableBooking-button":
                return <div className="DosaChutneyHome-TableBooking-button"
                    onClick={() => {
                        window.open(component?.Props?.href, '_blank')
                    }}
                >
                    {component?.Props?.btnText}
                </div>
            default:
                return <div />
        }

    }
    const getTableBooking = (src, components) => {
        return (
            <div className="DosaChutneyHome-TableBooking"
                style={{
                    backgroundImage: `linear-gradient(135deg, #1a330be3, #1a330be3), url(${src})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return getTableBookingComponent(component)
                })}
            </div>
        )
    }
    const MenuComponent = ({ menuItem, key }) => {
        return <div className="DosaChutneyHome-SpecialMenu-inner-grid-item" key={key}>
            <img className="DosaChutneyHome-SpecialMenu-inner-grid-item-img" alt="" src={menuItem?.src} />
            <div className="DosaChutneyHome-SpecialMenu-inner-grid-item-right">
                <div className="DosaChutneyHome-SpecialMenu-inner-grid-item-right-cont">
                    <div className="DosaChutneyHome-SpecialMenu-title ">
                        {menuItem?.title}
                    </div>
                    <div className="DosaChutneyHome-SpecialMenu-dots" />
                    <div className="DosaChutneyHome-SpecialMenu-price">
                        {menuItem?.price}
                    </div>
                </div>
                <div className="DosaChutneyHome-SpecialMenu-description">{menuItem?.description}</div>
            </div>
        </div>
    }
    const getSpecialMenuComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-SpecialMenu-header":
                return <HeaderText
                    header={component?.Props?.header} />
            case "DosaChutneyHome-SpecialMenu-content":
                return <div className="DosaChutneyHome-SpecialMenu-inner-text">
                    {component?.Props?.text} </div>
            case "DosaChutneyHome-SpecialMenu-menu":
                return <div className="DosaChutneyHome-SpecialMenu-inner-grid">
                    {component?.Data?.map((menuItem, key) => {
                        return (
                            <MenuComponent menuItem={menuItem} key={key} />
                        )
                    })}
                </div>
            case "DosaChutneyHome-SpecialMenu-button":
                return <div className="DosaChutneyHome-SpecialMenu-button"
                    onClick={() => {
                        window.open(component?.Props?.href, '_blank')
                    }} >
                    {component?.Props?.btnText}
                </div>
            default:
                return <div />
        }
    }
    const getSpecialMenu = (src, components) => {
        return (<div className="DosaChutneyHome-SpecialMenu"
            style={{
                backgroundImage: `url(${src})`
            }}>
            <div className="DosaChutneyHome-SpecialMenu-inner">
                {sortByOrderAscending(components).map((component, key) => {
                    return getSpecialMenuComponents(component)
                })}
            </div>
        </div>)
    }
    const getSubscriptionComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Subs-subheader":
                return <div className="DosaChutneyHome-Subs-subheader">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyHome-Subs-header":
                return <div className="DosaChutneyHome-Subs-header">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyHome-Subs-border":
                return <img alt="" src={border} className="DosaChutneyHome-Subs-border" />
            case "DosaChutneyHome-Subs-content":
                return <div className="DosaChutneyHome-Subs-content">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyHome-Subs-subscription":
                return <>
                    <div className="DosaChutneyHome-Subs-inputCont">
                        <div>

                            <input className={`DosaChutneyHome-Subs-inputCont-input ${errors.email !== "" ? "error" : ""}`}
                                placeholder={"Enter your email"}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                    setErrors({
                                        ...errors,
                                        ["email"]: "",
                                    });

                                }}
                                value={email} />
                            {
                                errors.email !== "" && < div className="input-error-text">
                                    {errors.email}
                                </div>
                            }</div>
                        <div className="DosaChutneyHome-Subs-inputCont-button"
                            onClick={handleContact}>
                            {loading ? <div
                                className="DosaChutneyHome-Subs-inputCont-button-loader-btn " /> : ""}         Subscribe
                        </div>
                    </div>
                    {showSuccess && < div className="succes-alert">
                        Subscription successful! Thanks for joining our newsletter. </div>}
                </>
            default:
                return <div />
        }

    }
    const getSubscription = (src, components) => {
        return (
            <div className="DosaChutneyHome-Subs"
                style={{
                    backgroundImage: `linear-gradient(135deg, #1a330be3, #1a330be3), url(${src})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return getSubscriptionComponent(component)
                })}
            </div>
        )
    }
    const getContainerComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Container-Menu":
                return getMenu(component?.Components)
            case "DosaChutneyHome-Container-About":
                return getAbout(component?.Components)
            case "DosaChutneyHome-Container-SpecialMenu":
                return getSpecialMenu(component?.Props?.src, component?.Components)
            case "DosaChutneyHome-Container-Subs":
                return getSubscription(component?.Props?.src, component?.Components)
            case "DosaChutneyHome-Container-Review":
                return getReviews(component?.Components)
            case "DosaChutneyHome-Container-TableBooking":
                return getTableBooking(component?.Props?.src, component?.Components)
            default:
                return <div />
        }
    }
    const getContainer = (components) => {
        return (
            <div className="DosaChutneyHome-Container">
                {sortByOrderAscending(components).map((component, key) => {
                    return getContainerComponents(component)
                })}
            </div>
        )
    }
    const getFixedContent = (component) => {
        return (<div className="DosaChutneyHome-MobileFixed">
            {component.map((component, key) => {
                let page = component?.Props
                return (
                    <div className="DosaChutneyHome-MobileFixed-cont" key={key}
                        onClick={() => {
                            if (page?.href?.includes("https://")) {
                                if (page?.href && page?.href !== "") {
                                    window.open(page?.href, '_blank')
                                }
                            } else {
                                history.push(page?.href)
                            }
                        }}>{page?.text}</div>)
            })}

        </div>)
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyHome-Hero":
                return <div className="DosaChutneyHome-Hero">
                    <ImageCarousel
                        content={component?.Data} />
                </div>
            case "DosaChutneyHome-Container":
                return getContainer(component?.Components)
            case "DosaChutneyHome-Map":
                return <div className="DosaChutneyHome-Map">
                    {companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                        lng={companyDetails?.address?.lng}
                    />}
                </div>
            case "DosaChutneyHome-Images":
                return getImagesCarousel(component?.Data)
            case "DosaChutneyHomeMobileFixed":
                return getFixedContent(component.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="DosaChutneyHome">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}


        </div>
    )
}
export default DosaChutneyHome